import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7193c1c6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "demo"
};
const _hoisted_2 = {
  style: {
    "margin-bottom": "10px",
    "clear": "both"
  }
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("常规编辑");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("行内编辑");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除勾选项");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存编辑信息");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("已保存");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("定期自动保存数据 ");

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 提交编辑过的人员信息 ");

import { ref, computed, onMounted } from "vue";
import { Modal, Message } from '@arco-design/web-vue';
import { IconRefresh } from '@arco-design/web-vue/es/icon';
import { BlitzTable, BlitzForm } from 'blitzar';
import 'blitzar/dist/style.css';
import schemaRaw, { operaterSchemaRaw, selectionSchemaRaw, idxSchemaRaw } from './schema';
import rowsData from "./data";
export default {
  setup(__props) {
    const mode = ref('raw'); // 防止失去焦点, 得准备两份数据

    let rowsRaw = rowsData;
    const rows = ref(rowsRaw);
    const tableSchema = computed(() => {
      operaterSchemaRaw[0].events.click = editItem;
      return mode.value === "edit" ? selectionSchemaRaw.concat(idxSchemaRaw).concat(schemaRaw) : selectionSchemaRaw.concat(idxSchemaRaw).concat(schemaRaw).concat(operaterSchemaRaw);
    });
    const selectedRows = ref([]);
    const editRowIds = ref([]);
    const editingItem = ref([]);
    const tableReloadKey = ref(false);
    const visible = ref(false);
    const modalVisible = ref(false);
    const isEdit = computed(() => mode.value === 'edit');
    const pagination = ref({
      pageSize: 10,
      current: 1
    });
    const paginationField = computed(() => {
      return {
        component: 'Pagination',
        total: 50,
        showPageSize: true,
        pageSize: pagination.value.pageSize,
        current: pagination.value.current,
        // @tofix 这一句会导致失去聚焦 
        // disabled: editRowIds.value.length > 0,
        events: {
          change: current => {
            if (editRowIds.value.length > 0) {
              Message.warning(`页面跳转前需要先保存编辑信息`);
              return false;
            } // console.log("当前页码: " + current)


            pagination.value.current = current;
            Message.info(`页面跳转${current}`);
          },
          pageSizeChange: pageSize => {
            if (editRowIds.value.length > 0) {
              Message.warning(`页面跳转前需要先保存编辑信息`);
              return false;
            } // console.log("每页数量: " + pageSize)


            pagination.value.pageSize = pageSize;
            pagination.value.current = 1;
          }
        }
      };
    });
    const searchField = false; // const searchField = {
    //   component: 'Input',
    //   placeholder: '筛选搜索...',
    //   debounce: 300,
    //   allowClear: true,
    // }

    const onUpdateCell = ({
      rowId,
      colId,
      value,
      origin
    }) => {
      if (!editRowIds.value.includes(rowId)) {
        editRowIds.value.push(rowId);
      }

      console.log('@updateCell', {
        rowId,
        colId,
        value,
        origin
      });
      const row = rows.value.find(r => r.id === rowId);
      if (!row) return;
      console.log("修改");
      row[colId] = value;
      console.log(rows.value);
    };

    const rowDeleted = rowIndex => {
      console.log(rowIndex); // console.log(rows.value)
      // @tip rowsRaw不需要再操作, 框架自动处理了
      // rowsRaw.splice(rowIndex, 1)

      rows.value.splice(rowIndex, 1);
    };

    const editItem = (_, formContext) => {
      // console.log(formContext.rowData)
      visible.value = true; // 数据是隔离后的副本

      editingItem.value = formContext.rowData; // item.value = Object.assign({}, formContext.rowData)
    };

    const submit = () => {
      console.log(rowsRaw);
      Modal.info({
        title: '显示全部信息',
        content: JSON.stringify(rows.value, null, 2)
      });
    };

    const submitEdit = () => {
      modalVisible.value = true;
    };

    const delSelected = () => {
      // console.log(selectedRows.value)
      // const selectedRowIds = selectedRows.value.map(i => i.id)
      // rowsRaw = rowsRaw.value.filter(i => !selectedRowIds.includes(i.id))
      // rows.value = rows.value.filter(i => !selectedRowIds.includes(i.id))
      // selectedRows.value = []
      Modal.error({
        title: '确认删除吗',
        content: JSON.stringify(selectedRows.value.map(i => i.firstName + " " + i.lastName), null, 2)
      });
    };

    const handleOk = () => {
      visible.value = false;
    };

    const handleCancel = () => {
      visible.value = false;
    };

    const handleModalOk = () => {
      editRowIds.value = [];
      console.log(editRowIds.value.length);
      modalVisible.value = false;
    };

    onMounted(() => {});
    return (_ctx, _cache) => {
      const _component_Option = _resolveComponent("Option");

      const _component_Select = _resolveComponent("Select");

      const _component_Button = _resolveComponent("Button");

      const _component_Space = _resolveComponent("Space");

      const _component_Alert = _resolveComponent("Alert");

      const _component_Drawer = _resolveComponent("Drawer");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Space, null, {
        default: _withCtx(() => [_createVNode(_component_Select, {
          id: "mode",
          modelValue: mode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => mode.value = $event),
          name: "mode",
          style: {
            "width": "250px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_Option, {
            value: "raw"
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          }), _createVNode(_component_Option, {
            value: "edit"
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_Button, {
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_Button, {
          disabled: selectedRows.value.length === 0,
          status: "danger",
          onClick: delSelected
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }, 8, ["disabled"]), _withDirectives(_createVNode(_component_Button, {
          disabled: editRowIds.value.length === 0,
          onClick: submitEdit
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }, 8, ["disabled"]), [[_vShow, _unref(isEdit)]])]),
        _: 1
      }), _createVNode(_component_Space, {
        style: {
          "float": "right"
        }
      }, {
        default: _withCtx(() => [_unref(isEdit) && editRowIds.value.length === 0 ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          type: "success",
          closable: ""
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })) : _createCommentVNode("", true), _unref(isEdit) ? (_openBlock(), _createBlock(_component_Alert, {
          type: "info",
          "show-icon": false,
          key: editRowIds.value.map(i => i).join('_')
        }, {
          default: _withCtx(() => [_hoisted_9, _createVNode(_unref(IconRefresh), {
            "stroke-width": 3,
            style: {
              fontSize: '16px'
            },
            spin: ""
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]), (_openBlock(), _createBlock(_unref(BlitzTable), {
        rows: _unref(rowsRaw),
        key: tableReloadKey.value + '_' + selectedRows.value.map(i => i.id).join('_') + '_' + rows.value.map(i => i.id).join('_') + '_' + mode.value + '_' + pagination.value.pageSize + '_' + pagination.value.current,
        selectedRows: selectedRows.value,
        "onUpdate:selectedRows": _cache[1] || (_cache[1] = $event => selectedRows.value = $event),
        sortable: false,
        labelPosition: "left",
        schemaColumns: _unref(tableSchema),
        mode: mode.value,
        rowsPerPage: pagination.value.pageSize,
        paginationField: _unref(paginationField),
        searchField: searchField,
        onRowDeleted: rowDeleted,
        onUpdateCell: onUpdateCell
      }, null, 8, ["rows", "selectedRows", "schemaColumns", "mode", "rowsPerPage", "paginationField"])), _createVNode(_component_Drawer, {
        visible: visible.value,
        width: 500,
        onOk: handleOk,
        onCancel: handleCancel,
        unmountOnClose: ""
      }, {
        title: _withCtx(() => [_createTextVNode(" 编辑 " + _toDisplayString(editingItem.value.firstName) + " " + _toDisplayString(editingItem.value.lastName), 1)]),
        default: _withCtx(() => [_createVNode(_unref(BlitzForm), {
          showErrorsOn: "always",
          labelPosition: "left",
          labelWidth: "100px",
          modelValue: editingItem.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => editingItem.value = $event),
          mode: "edit",
          schema: _unref(schemaRaw),
          columnCount: 1
        }, null, 8, ["modelValue", "schema"])]),
        _: 1
      }, 8, ["visible"]), _createVNode(_unref(Modal), {
        visible: modalVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => modalVisible.value = $event),
        onOk: handleModalOk,
        onCancel: _cache[4] || (_cache[4] = $event => modalVisible.value = false)
      }, {
        title: _withCtx(() => [_hoisted_10]),
        default: _withCtx(() => [_createElementVNode("pre", null, "" + _toDisplayString(JSON.stringify(rows.value.filter(i => editRowIds.value.includes(i.id)).map(i => i.firstName + " " + i.lastName), null, 2)) + "\r\n", 1)]),
        _: 1
      }, 8, ["visible"])]);
    };
  }

};